import VingtQuatreSeptImage from 'assets/images/consortium/24-7.png'
import DMSImage from 'assets/images/consortium/37dms.png'
import ActImage from 'assets/images/consortium/act.png'
import AnefImage from 'assets/images/consortium/anepf.png'
import CapunipharmImage from 'assets/images/consortium/capunipharm.png'
import CeidoImage from 'assets/images/consortium/ceido.png'
import DephieImage from 'assets/images/consortium/dephie.png'
import EpitopImage from 'assets/images/consortium/epitop.png'
import FspfImage from 'assets/images/consortium/fspf.png'
import GipharImage from 'assets/images/consortium/giphar.png'
import GiropharmImage from 'assets/images/consortium/giropharm.png'
import NormandiePharma from 'assets/images/consortium/opso-sante.png'
import OxygenImage from 'assets/images/consortium/oxygenpharma.png'
import Pharma2mImage from 'assets/images/consortium/pharma2m.png'
import PharmuppImage from 'assets/images/consortium/pharmupp.png'
import SynapsImage from 'assets/images/consortium/synaps.png'
import TeampharmaImage from 'assets/images/consortium/teampharma1.png'
import TotumImage from 'assets/images/consortium/totum6.png'
import UspoImage from 'assets/images/consortium/uspo.png'
import PartnerCard from 'components/landing/TrustGrouping/PartnerCard'
import { type FC } from 'react'
import styled from 'styled-components'
import { colors } from 'theme'

const trustList = [
  {
    image: GiropharmImage,
    url: 'https://www.giropharm.fr/',
  },
  {
    image: FspfImage,
    url: 'http://www.fspf.fr',
  },
  {
    image: UspoImage,
    url: 'https://uspo.fr',
  },
  {
    image: VingtQuatreSeptImage,
    url: 'https://www.24-7services.eu/',
  },
  {
    image: GipharImage,
    url: 'https://www.giphar.fr/',
  },
  {
    image: PharmuppImage,
    url: 'https://www.pharm-upp.fr/',
  },
  {
    image: CapunipharmImage,
    url: 'http://www.capunipharm.fr/',
  },
  {
    image: CeidoImage,
    url: 'https://www.ceido.com/',
  },
  {
    image: TotumImage,
    url: 'https://www.totum.fr/',
  },
  {
    image: ActImage,
    url: 'https://actpharmacie.fr/',
  },
  {
    image: DephieImage,
    url: 'https://www.dephie.com/',
  },
  {
    image: EpitopImage,
    url: 'https://epitop.fr/',
  },
  {
    image: OxygenImage,
    url: 'https://www.oxygen-pharma.fr/',
  },
  {
    image: Pharma2mImage,
    url: 'https://pharma2m.fr/',
  },
  {
    image: AnefImage,
    url: 'https://anepf.org/',
  },
  {
    image: DMSImage,
    url: 'https://37degres-masante.fr',
  },
  {
    image: TeampharmaImage,
    url: 'https://www.groupement-team-pharma.com/',
  },
  {
    image: SynapsImage,
    url: 'https://www.synaps-pharma.com/',
  },
  {
    image: NormandiePharma,
    url: 'https://www.opsosante.fr/',
  },
]

const TrustGrouping: FC = () => (
  <>
    <Title>
      Ils nous font&nbsp;
      <TitleColored>confiance</TitleColored>
    </Title>
    <TrustList>
      {trustList.map((info, i) => (
        <Wrapper key={i}>
          <PartnerCard
            image={info.image}
            url={info.url}
          />
        </Wrapper>
      ),
      )}
    </TrustList>
  </>
)

const Title = styled.h2`
  font-family: "brother-1816";
  font-size: 2.25rem;
  font-weight: bold;
  color: ${colors.midnightBlue};
  text-align: center;
`

const TitleColored = styled.span`
  color: ${colors.lightGreen};
`

const TrustList = styled.ul`
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  justify-content: center;
  padding: 0;
  margin: 0 2rem 20rem;
`

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 25.438rem;
  height: 10.625rem;
  margin: 1rem;
  background-color: ${colors.white};
  border-radius: 0.5rem;
  box-shadow: 0 0.188rem 0.75rem 0 rgb(0 0 0 / 12%);
`

export default TrustGrouping
